module.exports = __webpack_public_path__ + "img/EMSD.f99c1152.jpg";